import { useState } from "react";

function RMprofileplayersmodal({ data, profileData, playerIndexNameKey }) {
    const [activeTab, setActiveTab] = useState(0);
    const getTop5Players = () => {
        if (!data || !data[playerIndexNameKey]) return [];

        const players = [...data[playerIndexNameKey]];

        if (playerIndexNameKey === "my_kd_ip") {
            // Keep existing behavior for Impact Players (no top 5 filtering)
            return players;
        }

        // For Top Distributor: sort by rank (ascending = rank 1 is best) and take top 5
        return players
            .sort((a, b) => (a.rank ?? Infinity) - (b.rank ?? Infinity))
            .slice(0, 5);
    };

    const players = getTop5Players();

    return (
        <>
            <div className="modal fade rmplayersprofile-modal-lg" tabIndex="-1" role="dialog"
                aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg rmplayerp-modal">
                    <div className="modal-content rmplayer-modalcontent">

                        {/* Tab Content */}
                        <div className="tab-content" id="myTabContent">
                            {players.map((tab, index) => (
                                <div
                                    key={index}
                                    className={`tab-pane fade ${activeTab === index ? "show active" : ""}`}
                                    id={`content-${index}`}
                                    role="tabpanel"
                                    aria-labelledby={`tab-${index}`}
                                >
                                    <div className="profile-container text-center pt-3">
                                        <img
                                            src={tab.profile_pic && tab.profile_pic.trim() !== ""
                                                ? tab.profile_pic
                                                : "../images/BOR/avatar.jpg"}
                                            alt={tab.name}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = "../images/BOR/avatar.jpg";
                                            }}
                                        />
                                    </div>

                                    <div className="name-header text-center mt-4">
                                        <p>{tab.shopName}</p>
                                    </div>

                                    {/* Show Rank Badge for Top Distributor */}
                                    {playerIndexNameKey !== "my_kd_ip" && tab.rank && (
                                        <div className="rank-badge text-center mt-2">
                                            {/* <span className="badge badge-warning">
                                                Rank #{tab.rank}
                                            </span> */}
                                        </div>
                                    )}

                                    <div className="point1-box pr-5 pl-5">
                                        <div className="astraheader">
                                            <p>Astra</p>
                                        </div>
                                        <div className="astrapoints">
                                            {tab.astra > 0 &&
                                                Array(tab.astra).fill(null).map((_, i) => (
                                                    <img
                                                        key={i}
                                                        src="../images/BOR/brahmastra-stone1.png"
                                                        className="img-fluid astraimgstone"
                                                        alt="Astra"
                                                    />
                                                ))}
                                            <span>{tab.astra} Completed</span>
                                        </div>
                                    </div>

                                    <div className="point2-box pr-5 pl-5">
                                        <div className="pointheader">
                                            <p>Points</p>
                                        </div>
                                        <div className="pointsh">
                                            <p>{tab.points}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Title */}
                        <div className="impctplayer-titlebox text-center">
                            <span>
                                {playerIndexNameKey === "my_kd_ip" ? "Impact Players" : "Top Distributor"}
                            </span>
                        </div>

                        {/* Nav Tabs — shows top 5 distributors as tabs */}
                        <ul className="nav rmpp-navtab nav-tabs mt-5" id="myTab" role="tablist">
                            {players.map((tab, index) => (
                                <li className="nav-item text-center" key={index}>
                                    <a
                                        className={`nav-link rmbtn-link ${activeTab === index ? "active" : ""}`}
                                        id={`tab-${index}`}
                                        data-toggle="tab"
                                        href={`#content-${index}`}
                                        role="tab"
                                        aria-controls={`content-${index}`}
                                        aria-selected={activeTab === index}
                                        onClick={() => setActiveTab(index)}
                                    >
                                        <img
                                            src={tab.profile_pic}
                                            className="modal-tabimg"
                                            alt=""
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = "../images/BOR/avatar.jpg";
                                            }}
                                        />
                                        <p className="pnm">{tab.shopName}</p>
                                        {/* {playerIndexNameKey !== "my_kd_ip" && tab.rank && (
                                            <p className="pnm" style={{ fontSize: "10px", margin: 0 }}>
                                                #{tab.rank}
                                            </p>
                                        )} */}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {/* Close Button */}
                        <div className="footerclose-contaner" id="rmplayer-fotterclsbtn">
                            <button type="button" className="close prmclsebtn"
                                data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <img src="../images/BOR/close-button.png" className="img-fluid w-50" />
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RMprofileplayersmodal;